import React from 'react';

type Props = React.ComponentProps<'a'> & {
  as?: 'a' | 'button';
};

export const GradientButton: React.FC<Props> = ({ as = 'a', className = '', children, ...rest }) => {
  const BaseTag: any = as;
  return (
    <BaseTag
      className={`group relative inline-flex items-center justify-center rounded-mdx px-6 py-3 font-medium transition-all duration-200 bg-white/8 backdrop-blur-sm border border-white/20 text-ink hover:bg-white/12 hover:border-white/30 ${className}`}
      {...rest}
    >
      <span className="absolute -inset-[1px] rounded-mdx bg-gradient-to-r from-brand-gold1 to-brand-gold2 opacity-40 blur-[8px] transition-opacity duration-200 group-hover:opacity-70" aria-hidden="true" />
      <span className="relative z-10">{children}</span>
    </BaseTag>
  );
};

export default GradientButton;
